if (!customElements.get("recently-viewed")) {
  class RecentlyViewed extends HTMLElement {
    constructor() {
      super();
      this.cookie = null;
      this.productHandle = null;
      this.productSlider = null;
    }

    connectedCallback() {
      this.container = this.querySelector(".js-recently-viewed__container");
      this.productHandle = this.dataset.productHandle;
      this.productSlider = this.querySelector("product-slider");

      this.getCookie();

      this.setCookie();

      this.populateSlider();
    }

    setCookie() {
      if (!this.productHandle) return;

      let cookieSet = new Set(this.cookie);
      cookieSet = new Set([this.productHandle, ...cookieSet]);
      this.cookie = Array.from(cookieSet).slice(0, 8);
      const date = new Date();
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `recentlyViewed=${JSON.stringify(this.cookie)}; ${expires}; path=/`;
    }

    getCookie() {
      const cookie = document.cookie.split("; ").find((row) => row.startsWith("recentlyViewed"));

      try {
        this.cookie = cookie ? JSON.parse(cookie.split("=")[1]) : [];
        if (!Array.isArray(this.cookie)) throw new Error("Invalid cookie format");
      } catch (error) {
        console.error("Error parsing recently viewed cookie:", error);
        this.cookie = [];
      }
    }

    async populateSlider() {
      this.container.innerHTML = "";
      const tasks = this.cookie.map((productHandle) => RecentlyViewed.fetchProduct(productHandle));
      const productSlides = await Promise.all(tasks);

      this.container.innerHTML = productSlides.join("");

      if (this.productSlider && typeof this.productSlider.initSwiper === "function") {
        this.productSlider.initSwiper();
      }
    }

    static async fetchProduct(productHandle) {
      try {
        const response = await fetch(
          `${window.Shopify.routes.root}products/${productHandle}?section_id=last-viewed-product`,
        );
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const slide = html.querySelector(".js-product-slide");

        if (!response.ok) {
          throw new Error("");
        }

        return slide ? slide.outerHTML : "";
      } catch (error) {
        console.error(error);
        return "";
      }
    }
  }

  customElements.define("recently-viewed", RecentlyViewed);
}
